import React from 'react';
import NavLink from '../ui/buttons/links/NavLink';
import { routes } from '../../../app/router/routes';
import { FaUser } from 'react-icons/fa';

const VineyardAccountLink = () => {
  return (
    <NavLink
      disableAnimation
      className={'flex flex-row items-center'}
      to={routes.vineyardProducts}
    >
      <FaUser className={'mr-2'} />
      Moje konto
    </NavLink>

  );
};

export default VineyardAccountLink;
